import {
  Component,
  EventEmitter,
  input,
  InputSignal,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-file-uploader-item',
  templateUrl: './file-uploader-item.component.html',
  styleUrls: ['./file-uploader-item.component.scss'],
})
export class FileUploaderItemComponent {
  file: InputSignal<File> = input<File>();

  @Output()
  remove: EventEmitter<File> = new EventEmitter();

  removeItem(file: File): void {
    this.remove.emit(file);
  }
}
